module.exports = __webpack_public_path__ + "img/story-unreal.08197152.svg";